module.exports = __webpack_public_path__ + "static/img/qtcj07.6cefa9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/qtcj07.png
// module id = 467
// module chunks = 0